import { MyTableComponent, Button } from "components"
import { useState } from "react"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"

export const RouteColor = () => {
 const [selectedColor, setSelectedColor] = useState("red")

 // colorpicker method
 const handleColorChange = (color: string | any) => {
  setSelectedColor(color?.hex)
 }
 // language translator
 const { t } = useTranslation("translation")
 const data = [
  {
   infoone: "0",
   infotwo: "0",
  },
  {
   infoone: "0",
   infotwo: "0",
  },
  {
   infoone: "0",
   infotwo: "0",
  },
  {
   infoone: "0",
   infotwo: "0",
  },
  {
   infoone: "0",
   infotwo: "0",
  },
 ]

 const columns = [
  {
   Header: "Startwert",
   Cell: ({ row }: any) => (
    <div className="bg-gray  py-2 rounded pl-2 text-start text-black">{row.original.infoone}</div>
   ),
  },
  {
   Header: t("Color"),
   Cell: () => (
    <div className="flex justify-center">
     <div className="w-6 h-6">
      <input
       className="w-full "
       type="color"
       value={selectedColor}
       onChange={(e) => handleColorChange(e.target.value)}
      />
     </div>
    </div>
   ),
  },
  {
   Header: t("displayValue"),
   Cell: ({ row }: any) => (
    <div className="bg-gray py-2 rounded pl-2 text-start text-black">{row.original.infotwo}</div>
   ),
  },
  {
   Header: t("start"),
   Cell: () => (
    <div className="flex justify-center">
     <div>
      <Button size={"tableSmallSize"} color={"pink"}>
       {t("remove")}
      </Button>
     </div>
    </div>
   ),
  },
 ]

 return (
  <div className="relative h-screen  md:h-screen lg:h-full w-[96%] mx-auto">
   <h1 className="Jakarta-font font-bold text-xl py-6">{t("editStatusColors")}</h1>

   <Box
    bg="highlight"
    className="flex lg:flex-row flex-col lg:justify-between lg:items-center py-4 px-2"
   >
    <h1 className="Jakarta-font font-bold text-xl">{t("editStatusColors")}</h1>
    <div className="flex lg:flex-row flex-col lg:items-center">
     <div className=" lg:mr-2">
      <Button size={"doublexl"}>Forum Gera</Button>
     </div>
     <Box bg="text" className="rounded py-2">
      <Button size={"doublexl"} color={"gray"}>
       Test Server
      </Button>
     </Box>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent fullHeight={false} columns={columns} data={data} paginate={true} />
  </div>
 )
}
